import { EntityStoreService } from './../../entity-store/entity-store.service';
import { MultiCanvasService } from './../../multi-canvas/multi-canvas.service';
import { CrosslineController, FovController, RingContrller } from './event-distribute.component';
import { Injectable } from '@angular/core';
import { intersectBoundingBox2 } from '../share/boundingbox2';

export interface HandleProperty {
  enable: boolean;
  tag: string;
}
export interface EventHandler {
  ring: HandleProperty;
  line: HandleProperty;
  crossline: HandleProperty;
  fov: HandleProperty;
}
export interface FovHandler {
  fov1: HandleProperty;
  fov2: HandleProperty;
  fov3: HandleProperty;
}
@Injectable({
  providedIn: 'root',
})
export class EventDistributeService {
  // TODO: make a visiable and avaliable entity-list

  eventHandler: EventHandler = {
    ring: { enable: false, tag: 'drag' },
    line: { enable: false, tag: 'drag' },
    crossline: { enable: false, tag: 'drag' },
    fov: { enable: true, tag: 'stop drag' },
  };
  fovHandler: FovHandler = {
    fov1: { enable: false, tag: 'drag' },
    fov2: { enable: false, tag: 'drag' },
    fov3: { enable: false, tag: 'drag' },
  }
  constructor(
  ) {}
  doDrag() {}
  noDrag() {}
  ifDrag() {
    if (
      this.eventHandler.ring.enable ||
      this.eventHandler.line.enable ||
      this.eventHandler.crossline.enable ||
      this.eventHandler.fov.enable
    ) {
      this.doDrag();
    } else {
      this.noDrag();
    }
  }

  drag(handleProperty: HandleProperty) {
    if (handleProperty.enable) {
      handleProperty.enable = false;
      this.ifDrag();
      handleProperty.tag = 'drag';
    } else {
      handleProperty.enable = true;
      this.ifDrag();
      handleProperty.tag = 'stop drag';
    }
  }
  dragRing() {
    this.drag(this.eventHandler.ring);
  }
  dragLine() {
    this.drag(this.eventHandler.line);
  }
  dragCrossline() {
    this.drag(this.eventHandler.crossline);
  }
  dragFov() {
    this.drag(this.eventHandler.fov);
  }
  dragFov1() {
    this.drag(this.fovHandler.fov1);
  }
  dragFov2() {
    this.drag(this.fovHandler.fov2);
  }
  dragFov3() {
    this.drag(this.fovHandler.fov3);
  }
}
